import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/tokenomics.css';
import Bubble from '../components/Bubble';

const Tokenomics = () => {
  const { t } = useTranslation();

  return (
    <div className="tokenomics-page">
      <h1 className="tokenomics-title">{t('tokenomics.page.title')}</h1>
      
      <div className="bubble-container">
        {/* Primera fila: Burbujas 1 y 2 */}
        <div className="bubble-row">
          <Bubble 
            className="bubble-1"
            title={t('tokenomics.intro.title')}
            content={t('tokenomics.intro.content')}
            color="blue"
            size="medium"
          />
          <Bubble 
            className="bubble-2"
            title={t('tokenomics.distribution.title')}
            content={
              <ul>
                <li>{t('tokenomics.distribution.content')}</li>
                {t('tokenomics.distribution.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            }
            color="green"
            size="medium"
          />
        </div>
        
        {/* Segunda fila: Burbujas 3 y 4 */}
        <div className="bubble-row">
          <Bubble 
            className="bubble-3"
            title={t('tokenomics.purpose.title')}
            content={t('tokenomics.purpose.content')}
            color="orange"
            size="medium"
          />
        </div>
        
        {/* Quinta fila: Burbujas 9 y 10 */}
        <div className="bubble-row">
          <Bubble 
            className="bubble-10"
            title={t('tokenomics.utility.title')}
            content={
              <ul>
                {t('tokenomics.utility.items', { returnObjects: true }).map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            } 
            color="green"
            size="medium"
          />
        </div>
      </div>
    </div>
  );
};

export default Tokenomics;
